/**
 * bfs 图片裁剪
 * @param url
 * @param imgWidth
 * @returns
 */
 export function cutImage(url: string, imgWidth: number) {
  if (typeof url !== "string") {
    return url;
  }
  url = url.trim();
  const reg = /^http:\/\/|https:\/\//;
  if (reg.test(url)) {
    url = url.replace(reg, "//");
  }

  const bfs = url.indexOf("/bfs/") !== -1;
  const gif = url.indexOf(".gif") !== -1;
  const webp = url.indexOf(".webp") !== -1;

  if (!bfs || gif || webp) {
    return url;
  }
  const urls = url.split("?");

  const sizes = {
    midfix: "@" + imgWidth + "w",
    suffix: "@" + imgWidth + "w"
  };

  let matches: RegExpExecArray | null = null;
  const rules = {
    cdn: /^\/\/i[0-2]\.hdslb\.com\//,
    bfs: /^\/\/i\d\.hdslb\.com\/bfs\//,
    group1: /^\/\/i\d\.hdslb\.com\/group1\//,
    other: /(^\/\/i\d\.hdslb\.com)(\/.+)/
  };
  const feature = {
    bfs: /_\d+x\d+\./,
    other: /\/\d+_\d+\//
  };

  if (!rules.cdn.test(urls[0])) {
    return url;
  }
  if (feature.bfs.test(urls[0]) || feature.other.test(urls[0])) {
    return url;
  }
  if (rules.bfs.test(urls[0]) || rules.group1.test(urls[0])) {
    if (typeof imgWidth !== "undefined") {
      urls[0] += sizes.suffix + urls[0].slice(urls[0].lastIndexOf("."));
    }
    url = urls.join("?");
  } else {
    matches = rules.other.exec(urls[0]);
    if (matches) {
      urls[0] = matches[1] + sizes.midfix + matches[2];
      url = urls.join("?");
    }
  }

  return url;
}
